<div class="relative h-[60px] w-full overflow-hidden">
  <img
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/register.webp"
    alt="icon_register"
    class="absolute inset-0 h-full w-full object-cover" />
  <div
    class="absolute inset-0"
    style="background: linear-gradient(90deg, rgba(32, 42, 56, 0.6) 0%, rgba(1, 14, 21, 0.6) 100%)"></div>

  <div class="absolute inset-0 flex items-center justify-center">
    <p class="font-barlow text-blue-sky text-center text-xl leading-7 font-extrabold tracking-[0] italic">
      PROGRESO EN REGIÓN: {{ user()?.escuderia | uppercase }}
    </p>
  </div>
</div>
